import PropTypes from 'prop-types'
import React from 'react'
import { Sync, Tooltip } from '@segment/icons/react'
import './StatusLabel.css'

const StatusLabel = props => {
  const { children, status } = props
  const Icon = getIcon(status)
  let icon = null

  let classes = ['StatusLabel']

  if (Icon) {
    icon = (
      <div className="StatusLabel-icon">
        <Icon color="white" />
      </div>
    )
  } else {
    classes.push('StatusLabel-NoIcon')
  }

  return (
    <div className={classes.join(' ')} data-status={status}>
      {icon}
      {children}
    </div>
  )
}

/**
 * Get the icon `type` for the given `status`.
 */

function getIcon(status) {
  if (status === 'running') return Sync
  if (status === 'success') return null
  if (status === 'error') return null
  if (status === 'unknown') return Tooltip
}

StatusLabel.propTypes = {
  children: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired
}

export default StatusLabel
